<template>
  <div class="search">
    <div class="search-box">
      <a href="javascript:void(0)" @click="onClick({type:'return'})" class="search-left">
        <i class="iconfont icon-return"></i>
      </a>
      <a href="javascript:void(0)" @click="onClick({type:'search'})" class="search-right">
        <i class="iconfont icon-sousuo"></i>
        <span>请输入关键词搜索</span>
      </a>
    </div>
    <div class="search-type">
      <span
        v-for="item in cats"
        :key="item.id"
        :class="item.id==catId?'active':''"
        @click="getCat(item)"
      >{{item.name}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["catId"],
  data() {
    return {
      cats: [
        { id: 1, name: "手机", link: "/shouji" },
        { id: 2, name: "平板", link: "/shouji" },
        { id: 19, name: "笔记本", link: "/shouji" },
        { id: 22, name: "台式机", link: "/shouji" },
        { id: 9, name: "相机", link: "/shouji" },
      ],
      active: 1
    };
  },
  mounted: function() {},
  methods: {
    getCat(item) {
      if (this.catId !== item.id) {
        window._hmt.push(['_trackEvent', '回收产品分类', '点击', item.name]);
        this.$emit("getCatId", item.id);
      }
    },
    onClick(item) {
      window._hmt.push(['_trackEvent', '回收分类顶部', '点击', item.type]); 
      if(item.type=='return'){
        this.$router.push({ path: "/" })
      }else if(item.type=='search'){
        this.$router.push({ path: "/mobile/oldproduct/search" })
      }
    }
  }
};
</script>

<style scoped>
.search {
  position: fixed;
  top: 0;
  width: 3.75rem;
  height: 0.9rem;
  background: #ff4747;
  z-index: 9999;
}
.search-box {
  display: flex;
  margin: 0.1rem 0 0 0;
  position: relative;
}
.search-box .search-right {
  background: #f6f7f8;
  border-radius: 5px;
}
.search-box .icon-return {
  font-size: 0.2rem;
  color: #fff;
  position: absolute;
  left: 0.1rem;
  top: 0.05rem;
}
.search-right {
  width: 3rem;
  line-height: 0.3rem;
  display: inline-block;
  margin-left: 0.4rem;
}
.search-box .icon-sousuo {
  margin: 0 0.1rem;
}
.search-box span {
  margin-left: 0rem;
}
.search-type {
  margin-top: 0.2rem;
}
.search-type span {
  display: inline-block;
  width: 0.6rem;
  text-align: center;
  color: #fff;
  position: relative;
  cursor: pointer;
}
.search-type span.active::before {
  content: "";
  display: inline-block;
  width: 0.3rem;
  height: 0.02rem;
  background: #000;
  position: absolute;
  bottom: -0.11rem;
  left: 27%;
}
</style>
